/**
 * Composable for charge validation rules and functions
 * @param {Object} charge - The charge object being validated
 * @param {Object} companySettings - Company settings containing validation requirements
 * @returns {Object} Validation rules and functions
 */
export default function useChargeValidation(charge, companySettings) {
  /**
   * Validation rules for the amount field
   */
  const amountValidationRules = [v => {
    if (v === null || v === undefined || v === '') {
      return 'Amount is required';
    }
    const num = parseFloat(v);
    if (Number.isNaN(num)) {
      return 'Amount must be a valid number';
    }
    if (num < 0) {
      return 'Amount must be a positive number (or zero)';
    }
    return true;
  }];

  /**
   * Validation rules for the description field
   */
  const descriptionValidationRules = [v => !!v && v.trim() !== '' || 'A description is required.'];

  /**
   * Validation rules for the limit rate field
   */
  const limitRateValidationRules = [v => !!v || 'A Limit Rate is required.'];

  /**
   * Comprehensive validation of charge data before submission
   * @returns {Array} Array of validation error messages, empty if valid
   */
  const validateChargeData = () => {
    const errors = [];
    if (!charge.description) {
      errors.push('Please include a description');
    }
    if (charge.amount === null || charge.amount === undefined || charge.amount === '' || Number.isNaN(Number(charge.amount)) || charge.amount < 0) {
      errors.push('Amount is required and must be a positive number (or zero)');
    }
    if (charge.label && charge.label.length > 255) {
      errors.push('Label is too long (max 255 characters)');
    }
    if (companySettings && companySettings.requireFixedFeeUser && !charge.account) {
      errors.push('The fixed fee must be assigned to a user');
    }
    if (charge.limit && charge.limit.hours && (!charge.limit.rate || !charge.limit.rate.amount)) {
      errors.push('Hour limit requires a rate');
    }
    if (!charge.matterDetail) {
      errors.push('Please select a matter');
    }
    return errors;
  };
  return {
    amountValidationRules,
    descriptionValidationRules,
    limitRateValidationRules,
    validateChargeData
  };
}